import Container from "../components/basicComponents/container";
import ImageUpload from "../components/basicComponents/image-upload";
import TextArea from "../components/basicComponents/text-area";
import TextInput from "../components/basicComponents/text-input";
import * as Icons from "../assets/SVGs/index";
import { useSelector, useDispatch } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import Button from "../components/basicComponents/button";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import {
  addDetail,
  getDetails,
  editDetail,
  removeDetail,
} from "../state-management/actions/detail-actions";
import { useEffect, useState } from "react";
import Grid from "../components/grid";
import ToggleSwitch from "../components/basicComponents/switch-box";
import {
  setAlert,
  setAlertContext,
  setAlertSeverity,
} from "../state-management/actions/alerts-actions";
import { FormDataProperty } from "../types/public";

const formDataInitialize: FormDataProperty = {
  name: "",
  title: "",
  description: "",
  index_picture: "",
  url: "",
  priority: 0,
  is_active: false,
};

export default function () {
  const { rowStatus } = useSelector(selectGlobalState);
  const dispatch = useDispatch();
  const [detailData, setDetailData] = useState<any>([]);
  const [updateFlag, setUpdateFlag] = useState<boolean>(false);
  const [formData, setFormData] =
    useState<FormDataProperty>(formDataInitialize);

  const handleAlert = (status: boolean) => {
    if (status) {
      dispatch(setAlert(true));
      dispatch(setAlertSeverity("success"));
      dispatch(setAlertContext(" عملیات با موفقیت تکمیل شد"));
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    const fetchData = async () => {
      const response = await getDetails()(dispatch);
      setDetailData(response.data);
    };
    fetchData();
    dispatch(setRowStatus("clear id", false));
    setFormData(formDataInitialize);
  }, [updateFlag]);

  const handleSubmit = async () => {
    try {
      await addDetail({ ...formData })(dispatch);
      handleAlert(true);
      setUpdateFlag((prev: any) => !prev);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleSetEditData = async (clear: boolean, id: string) => {
    const settingData = detailData.find((item: any) => item._id === id);
    console.log(settingData);
    if (settingData && !clear) {
      setFormData(settingData);
    } else if (clear) {
      setFormData(formDataInitialize);
    }
  };

  const handleEdit = async () => {
    try {
      await editDetail(rowStatus.id, formData)(dispatch);
      handleAlert(true);
      setUpdateFlag((prev: any) => !prev);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await removeDetail(id)(dispatch);
      if (response) {
        setUpdateFlag((prev: any) => !prev);
      }
    } catch (error: any) {
      console.log(error);
    }
  };
  return (
    <div className="flex flex-col items-center w-full">
      <Container header="فرم ثبت اطلاعات">
        <div
          className="md:grid md:grid-cols-4 md:grid-rows-2 justify-items-center w-full flex flex-col gap-2"
          style={{ direction: "rtl" }}
        >
          <TextInput
            name="name"
            label="نام"
            placeholder="نام"
            RightIcon={<Icons.UserIcon />}
            value={formData.name}
            onChange={handleChange}
          />
          <TextInput
            name="title"
            label="عنوان "
            placeholder="عنوان"
            RightIcon={<Icons.TitleIcon />}
            value={formData.title}
            onChange={handleChange}
          />
          <TextInput
            name="url"
            label="URL"
            placeholder="URL"
            RightIcon={<Icons.TitleIcon />}
            value={formData.url}
            onChange={handleChange}
          />
          <TextInput
            name="priority"
            label="الویت"
            placeholder="الویت"
            RightIcon={<Icons.UserIcon />}
            value={formData.priority}
            onChange={handleChange}
          />
        </div>
        <div className="w-full h-full flex md:flex-row flex-col gap-y-4 justify-between">
          <div className="md:w-[50%] w-full">
            <TextArea
              name="description"
              placeholder="توضیحات"
              value={formData.description}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  description: e.target.value,
                });
              }}
              rows={10}
            />
          </div>
          <div className=" flex flex-col justify-between  md:w-[39%] h-[200px] w-">
            <ImageUpload
              onImageChange={(file: any) => {
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    const base64String = reader.result as string;
                    setFormData((prev: any) => ({
                      ...prev,
                      index_picture: base64String,
                    }));
                    localStorage.setItem("detailImageBase64", base64String);
                  };
                  reader.readAsDataURL(file);
                } else {
                  setFormData((prev: any) => ({
                    ...prev,
                    index_picture: "",
                  }));
                  localStorage.removeItem("detailImageBase64");
                }
              }}
              storageKey="detailImageBase64"
              label="آپلود آیکون"
              defaultImage={formData.index_picture}
            />
            <div className="flex justify-between items-center w-full">
              <ToggleSwitch
                label=" وضعیت نمایش "
                checked={formData.is_active}
                onChange={() =>
                  setFormData((prev: any) => ({
                    ...prev,
                    is_active: !prev.is_active,
                  }))
                }
              />
              <Button
                variant={!rowStatus?.status ? "success" : "edit"}
                title={!rowStatus?.status ? "ثبت" : "ویرایش"}
                paddingx="20px"
                paddingy="6px"
                onClick={!rowStatus?.status ? handleSubmit : handleEdit}
              />
            </div>
          </div>
        </div>
      </Container>
      <Container header="جدول جزییات صفحات">
        <Grid
          height={800}
          columns={[
            { headerName: "نام", field: "name" },
            { headerName: "عنوان", field: "title" },
            { headerName: "URL", field: "url" },
            { headerName: "الویت نمایش", field: "priority" },
            { headerName: " وضعیت نمایش", field: "is_active" },
          ]}
          userData={detailData}
          pageSize={50}
          pagination={true}
          editBtn={true}
          deleteBtn={true}
          editable={false}
          handleDelete={handleDelete}
          handleSetData={handleSetEditData}
          btnHeader="عملیات"
        />
      </Container>
    </div>
  );
}
